import React from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Form, Input } from 'util/ui'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import FieldError from 'shared/components/ui/FieldError'
import SpacedItems from 'shared/components/ui/SpacedItems'
import themeVars from 'ui_theme/site/globals/site.variables'

import sharedStyles from '../../sharedForm/styles.less'
import Button from '../../sharedForm/Button'
import SaveIndicator from '../../sharedForm/SaveIndicator'
import EmailForm from '../../sharedForm/EmailForm'
import ResendToken from '../../sharedForm/ResendToken'
import PageHeader from '../PageHeader'

const EXPECTED_CODE_LENGTH = 6

const LargeFieldError = styled(FieldError)`
  margin-top: ${props => props.theme.spacing['10']};
  font-size: ${themeVars.fontSize} !important;
  &&& {
    font-style: normal !important;
  }
  & > .icon {
    font-size: ${themeVars['18px']} !important;
    line-height: ${themeVars['15px']};
    vertical-align: middle;
  }
`

class VerificationPage extends React.PureComponent {
  // eslint-disable-next-line react/sort-comp
  state = {
    errorDisplayable: false,
  }

  takeInputRef = input => {
    disableLastPassInputRef(input)
    this.inputRef = input.inputRef.current
  }

  handlePaste = e => {
    const value =
      (e.clipboardData || window.clipboardData).getData('text') || ''
    const parsedValue = value
      .replace(/[^0-9]/g, '')
      .substring(0, EXPECTED_CODE_LENGTH)
    this.props.onChange('confirmationToken', parsedValue, null, {
      validate: true,
    })
    e.preventDefault()
  }

  handleDigit = (_, { value }) => {
    this.props.onChange('confirmationToken', value, null, {
      validate: true,
    })
  }

  handleSubmit = (...args) => {
    this.setState({ errorDisplayable: true })
    this.props.submitForm(...args)
  }

  handleEmailFormSubmit = () => {
    this.props.onChange('confirmationToken', '', null, {
      validate: true,
    })
    this.inputRef.focus()
  }

  handleEmailFormClose = () => {
    this.inputRef.focus()
  }

  render() {
    const {
      formFields,
      formFieldsErrors,
      canSave,
      saving,
      email,
      isOnboardingComplete,
    } = this.props
    const error =
      this.state.errorDisplayable && formFieldsErrors.confirmationToken
    return (
      <React.Fragment>
        <PageHeader />
        <Form
          size="large"
          className={cn(sharedStyles.form, sharedStyles.formV3)}
        >
          <Form.Field>
            <label htmlFor="code">Verify your account</label>
            <div
              className="hint"
              css={css`
                color: #1b1b1b !important;
              `}
            >
              A 6 digit code has been sent to <strong>{email}</strong> to verify
              your email address.
            </div>
            <Input
              id="code-search"
              ref={this.takeInputRef}
              type="text"
              fluid
              onChange={this.handleDigit}
              onPaste={this.handlePaste}
              placeholder="Enter your 6 digit code"
              value={formFields.confirmationToken}
              autoComplete="off"
              maxLength="6"
              minLength="6"
              pattern="/[^0-9]/"
              autoFocus
            />
          </Form.Field>
          {error && <LargeFieldError as="div">{error}</LargeFieldError>}
          <Button
            primary
            size="big"
            fluid
            disabled={!canSave || saving || isOnboardingComplete}
            onClick={this.handleSubmit}
          >
            {!saving && !isOnboardingComplete ? (
              'Verify code'
            ) : (
              <SaveIndicator animate>Verifying code</SaveIndicator>
            )}
          </Button>
          <Form.Field>
            <SpacedItems.Container horizontalAlign="space-between">
              <SpacedItems.Item>
                <EmailForm
                  onSubmit={this.handleEmailFormSubmit}
                  onClose={this.handleEmailFormClose}
                />
              </SpacedItems.Item>
              <SpacedItems.Item>
                <ResendToken />
              </SpacedItems.Item>
            </SpacedItems.Container>
          </Form.Field>
        </Form>
      </React.Fragment>
    )
  }
}

export default VerificationPage
